import { render, staticRenderFns } from "./TabChecked.vue?vue&type=template&id=af2f5906&"
import script from "./TabChecked.vue?vue&type=script&lang=ts&"
export * from "./TabChecked.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports